/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Projects_Col_RkidInputs */

const cs_projects_col_rkid = /** @type {(inputs: Projects_Col_RkidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RK ID`)
};

const en_projects_col_rkid = /** @type {(inputs: Projects_Col_RkidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RK ID`)
};

/**
* | output |
* | --- |
* | "RK ID" |
*
* @param {Projects_Col_RkidInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const projects_col_rkid = /** @type {((inputs?: Projects_Col_RkidInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Projects_Col_RkidInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_projects_col_rkid(inputs)
	return cs_projects_col_rkid(inputs)
});